const mapEvents = [
    'onMouseDown',
    'onMouseUp',
    'onMouseOver',
    'onMouseOut',
    'onMouseMove',
    'onMouseEnter',
    'onMouseLeave',
    'onPreClick',
    'onClick',
    'onDblClick',
    'onContextMenu',
    'onTouchStart',
    'onTouchEnd',
    'onTouchCancel',
    'onWheel',
    'onResize',
    'onRemove',
    'onTouchMove',
    'onMoveStart',
    'onMove',
    'onMoveEnd',
    'onDragStart',
    'onDrag',
    'onDragEnd',
    'onZoomStart',
    'onZoom',
    'onZoomEnd',
    'onRotateStart',
    'onRotate',
    'onRotatEnd',
    'onPitchStart',
    'onPitch',
    'onPitchEnd',
    'onBoxZoomStart',
    'onBoxZoomEnd',
    'onBoxZoomCancel',
    'onWebglContextLost',
    'onWebglContextRestored',
    'onLoad',
    'onRender',
    'onIdle',
    'onError',
    'onData',
    'onStyleData',
    'onSourceData',
    'onDataLoading',
    'onStyleDataLoading',
    'onSourceDataLoading',
    'onStyleImageMissing',
];
const layerEvents = [
    'onMouseDown',
    'onMouseUp',
    'onMouseOver',
    'onMouseOut',
    'onMouseMove',
    'onMouseEnter',
    'onMouseLeave',
    'onClick',
    'onDblClick',
    'onContextMenu',
    'onTouchStart',
    'onTouchEnd',
    'onTouchCancel',
];
const drawEvents = [
    'onCreate',
    'onDelete',
    'onCombine',
    'onUncombine',
    'onUpdate',
    'onSelectionchange',
    'onModechange',
    'onRender',
    'onActionable',
];
export { mapEvents, layerEvents, drawEvents };
